import { useCallback, useContext } from "react";
import { useRecoilState } from "recoil";

import {
  PageHeaderContext,
  useCustomQueryParams,
  useDynamicTablesCleanup,
  usePageContext,
  usePreGlobalSearchCalendar,
  useResolveSearchFilteredRows,
} from "@ryde/redux";
import { RideCrudModeKey, tableSearchAF } from "@ryde/shared";

export const useTableFilterSearch = () => {
  const { entity } = usePageContext();
  const [tableSearch, setTableSearch] = useRecoilState(tableSearchAF(entity));
  const { isHasFilteredResult } = useResolveSearchFilteredRows();
  const { onSearchApply } = useContext(PageHeaderContext);
  const { setTableSearchQsByValue } = useCustomQueryParams();
  const { restoreSnapshotIfNeeded } = usePreGlobalSearchCalendar();
  const { resetPageOnSearchChange } = useDynamicTablesCleanup({ entity });

  const isError = tableSearch?.length > 0 && !isHasFilteredResult;

  const onChange = useCallback(
    (value: string) => {
      const applySearchState = (): void => {
        setTableSearch(value);
        setTableSearchQsByValue(value);
        resetPageOnSearchChange();

        // Clearing the id: chip must restore the pre-search calendar as well.
        if (!value && entity === RideCrudModeKey.uiUnit) {
          restoreSnapshotIfNeeded();
        }
      };

      applySearchState();
    },
    [
      entity,
      resetPageOnSearchChange,
      restoreSnapshotIfNeeded,
      setTableSearch,
      setTableSearchQsByValue,
    ],
  );

  return {
    searchValue: tableSearch,
    isError,
    onChange,
    onSearchApply,
  };
};
